/**
 * Paint Color Picker JavaScript
 * Rockbottom Northampton - With Product Filtering
 */

(function() {
  'use strict';

  // Product mapping - Crown product names to Shopify handles
  var PRODUCT_MAPPING = {
    // Crown Trade Interior
    "Crown Trade Matt Vinyl Emulsion": { handle: "crown-trade-vinyl-matt", name: "Crown Trade Vinyl Matt", type: "Matt Emulsion", desc: "Interior walls & ceilings", sizes: ["250ml", "1L", "2.5L"] },
    "Crown Trade Silk Vinyl Emulsion.  LEED and BREEAM accredited.": { handle: "crown-trade-vinyl-silk-tinted-1l", name: "Crown Trade Vinyl Silk", type: "Silk Emulsion", desc: "Kitchens & bathrooms", sizes: ["1L", "2.5L"] },
    "Crown Trade Mid Sheen Vinyl Emulsion.  LEED and BREEAM accredited.": { handle: "crown-trade-vinyl-silk-tinted-1l", name: "Crown Trade Vinyl Mid Sheen", type: "Mid Sheen", desc: "Kitchens & bathrooms", sizes: ["1L", "2.5L"] },
    // Crown Trade Trim
    "Crown Trade Eggshell": { handle: "crown-trade-eggshell-25l-tinted-platinum-base", name: "Crown Trade Eggshell", type: "Eggshell", desc: "Woodwork & trim", sizes: ["2.5L"] },
    "Crown Trade Acrylic Eggshell": { handle: "crown-trade-eggshell-25l-tinted-platinum-base", name: "Crown Trade Acrylic Eggshell", type: "Acrylic Eggshell", desc: "Woodwork & trim", sizes: ["2.5L"] },
    "Crown Trade Full Gloss": { handle: "crown-trade-fastflow-quick-dry-gloss-1l-tinted", name: "Crown Trade Gloss", type: "Gloss", desc: "Doors & woodwork", sizes: ["1L", "2.5L"] },
    "Crown Trade Satin Finish": { handle: "crown-trade-fastflow-quick-dry-satin-tinted", name: "Crown Trade Satin", type: "Satin", desc: "Woodwork & trim", sizes: ["1L", "2.5L"] },
    "Crown Trade Acrylic Satin Finish": { handle: "crown-trade-fastflow-quick-dry-satin-tinted", name: "Crown Trade Acrylic Satin", type: "Acrylic Satin", desc: "Woodwork & trim", sizes: ["1L", "2.5L"] },
    // Crown Trade Fastflow
    "Crown Trade Fastflow Quick Dry Eggshell": { handle: "crown-trade-fastflow-quick-dry-eggshell-tinted", name: "Crown Trade Fastflow Eggshell", type: "Quick Dry Eggshell", desc: "Quick dry trim", sizes: ["1L", "2.5L"] },
    "Crown Trade Fastflow Quick Dry Gloss": { handle: "crown-trade-fastflow-quick-dry-gloss-1l-tinted", name: "Crown Trade Fastflow Gloss", type: "Quick Dry Gloss", desc: "Doors & woodwork", sizes: ["1L", "2.5L"] },
    "Crown Trade Fastflow Quick Dry Satin": { handle: "crown-trade-fastflow-quick-dry-satin-tinted", name: "Crown Trade Fastflow Satin", type: "Quick Dry Satin", desc: "Woodwork & trim", sizes: ["1L", "2.5L"] },
    "Crown Trade Fastflow Quick Dry Primer Undercoat": { handle: "crown-trade-fastflow-quick-dry-satin-tinted", name: "Crown Trade Fastflow Primer", type: "Primer", desc: "Primer & undercoat", sizes: ["1L", "2.5L"] },
    // Crown Trade Clean Extreme
    "Crown Trade Clean Extreme Scrubbable Matt": { handle: "crown-trade-clean-extreme-25l-tinted-titanium-base", name: "Crown Trade Clean Extreme Matt", type: "Scrubbable Matt", desc: "High traffic areas", sizes: ["2.5L"] },
    "Crown Trade Clean Extreme Durable Acrylic Eggshell": { handle: "crown-trade-clean-extreme-25l-tinted-titanium-base", name: "Crown Trade Clean Extreme Eggshell", type: "Durable Eggshell", desc: "High traffic areas", sizes: ["2.5L"] },
    "Crown Trade Clean Extreme": { handle: "crown-trade-clean-extreme-25l-tinted-titanium-base", name: "Crown Trade Clean Extreme", type: "Scrubbable Matt", desc: "High traffic areas", sizes: ["2.5L"] },
    "Clean Extreme": { handle: "crown-trade-clean-extreme-25l-tinted-titanium-base", name: "Crown Trade Clean Extreme", type: "Scrubbable Matt", desc: "High traffic areas", sizes: ["2.5L"] },
    // Macpherson Trade Interior
    "Macpherson Vinyl Matt": { handle: "macpherson-vinyl-matt-tinted-5l", name: "Macpherson Vinyl Matt", type: "Matt Emulsion", desc: "Interior walls & ceilings", sizes: ["5L"] },
    "Macpherson Eclipse Emulsion": { handle: "macpherson-eclipse-emulsion-tinted", name: "Macpherson Eclipse Emulsion", type: "Matt Emulsion", desc: "Premium interior walls", sizes: ["5L", "10L"] },
    "Macpherson Eggshell": { handle: "macpherson-durable-acrylic-matt-tinted-25l-mc1-base", name: "Macpherson Acrylic Matt", type: "Acrylic Matt", desc: "Durable interior", sizes: ["2.5L"] },
    "Macpherson Gloss": { handle: "macpherson-gloss-tinted", name: "Macpherson Gloss", type: "Gloss", desc: "Doors & woodwork", sizes: ["1L", "2.5L"] },
    "Macpherson Quick Dry Gloss": { handle: "macpherson-gloss-tinted", name: "Macpherson Gloss", type: "Quick Dry Gloss", desc: "Doors & woodwork", sizes: ["1L", "2.5L"] },
    "Macpherson Quick Dry Satin": { handle: "macpherson-gloss-tinted", name: "Macpherson Satin", type: "Quick Dry Satin", desc: "Woodwork & trim", sizes: ["1L", "2.5L"] },
    "Macpherson Quick Dry Eggshell": { handle: "macpherson-gloss-tinted", name: "Macpherson Eggshell", type: "Quick Dry Eggshell", desc: "Woodwork & trim", sizes: ["1L", "2.5L"] },
    "Macpherson Floor Paint": { handle: "macpherson-floor-paint-tinted-mc3", name: "Macpherson Floor Paint", type: "Floor Paint", desc: "Interior floors", sizes: ["2.5L", "5L"] },
    "Macpherson Mid Sheen": { handle: "macpherson-eclipse-emulsion-tinted", name: "Macpherson Mid Sheen", type: "Mid Sheen", desc: "Interior walls", sizes: ["5L", "10L"] },
    "Macpherson Vinyl Silk": { handle: "macpherson-eclipse-emulsion-tinted", name: "Macpherson Vinyl Silk", type: "Silk Emulsion", desc: "Kitchens & bathrooms", sizes: ["5L", "10L"] },
    "Macpherson Satin Finish": { handle: "macpherson-gloss-tinted", name: "Macpherson Satin", type: "Satin", desc: "Woodwork & trim", sizes: ["1L", "2.5L"] },
    // Sadolin Woodstains
    "Sadolin Classic All Purpose Woodstain": { handle: "sadolin-classic-tinted", name: "Sadolin Classic", type: "Woodstain", desc: "All purpose woodstain", sizes: ["1L", "2.5L"] },
    "Sadolin Extra Durable Woodstain": { handle: "sadolin-extra-25l-tinted-clear-065-base", name: "Sadolin Extra", type: "Woodstain", desc: "Durable woodstain", sizes: ["1L", "2.5L"] },
    "Sadolin Quick Dry Woodstain": { handle: "sadolin-extra-25l-tinted-clear-065-base", name: "Sadolin Quick Dry", type: "Quick Dry Woodstain", desc: "Fast drying woodstain", sizes: ["1L", "2.5L"] },
    "Superdec Satin": { handle: "sadolin-superdec-25l-tinted", name: "Sadolin Superdec", type: "Exterior Wood", desc: "Exterior wood", sizes: ["1L", "2.5L"] },
    "Sadolin Beautiflex": { handle: "sadolin-superdec-25l-tinted", name: "Sadolin Superdec", type: "Exterior Wood", desc: "Flexible exterior", sizes: ["1L", "2.5L"] },
    // Sandtex Masonry
    "Sandtex Trade High Cover Smooth": { handle: "sandtex-high-cover-smooth-5l-tinted-crystal-base", name: "Sandtex High Cover Smooth", type: "Masonry Paint", desc: "Exterior masonry", sizes: ["5L"] },
    "Sandtex Trade 365 All Weather Masonry Paint": { handle: "sandtex-high-cover-smooth-5l-tinted-crystal-base", name: "Sandtex 365 Masonry", type: "Masonry Paint", desc: "All weather masonry", sizes: ["5L"] },
    "Sandtex Trade X-treme X-posure Smooth": { handle: "sandtex-high-cover-smooth-5l-tinted-crystal-base", name: "Sandtex X-treme", type: "Masonry Paint", desc: "Extreme weather protection", sizes: ["5L"] },
    "Sandtex Trade Eggshell X-tra": { handle: "sandtex-eggshell", name: "Sandtex Eggshell", type: "Exterior Eggshell", desc: "Exterior trim", sizes: ["2.5L"] },
    "Sandtex Trade Flexigloss X-tra": { handle: "sandtex-eggshell", name: "Sandtex Flexigloss", type: "Exterior Gloss", desc: "Flexible gloss", sizes: ["2.5L"] },
    "Sandtex Trade Fine Textured Matt": { handle: "sandtex-high-cover-smooth-5l-tinted-crystal-base", name: "Sandtex Textured Matt", type: "Textured Masonry", desc: "Textured masonry", sizes: ["5L"] },
    "Sandtex Trade Metal Gloss X-tra": { handle: "sandtex-eggshell", name: "Sandtex Metal Gloss", type: "Metal Gloss", desc: "Metal surfaces", sizes: ["2.5L"] },
    // Crown Trade Timonox (Fire Retardant)
    "Crown Trade Timonox Vinyl Matt": { handle: "crown-trade-vinyl-matt", name: "Crown Trade Timonox Vinyl Matt", type: "Fire Retardant Matt", desc: "Fire retardant interior", sizes: ["2.5L", "5L"] },
    "Crown Trade Timonox Scrubbable Matt": { handle: "crown-trade-clean-extreme-25l-tinted-titanium-base", name: "Crown Trade Timonox Scrubbable", type: "Fire Retardant Matt", desc: "Fire retardant scrubbable", sizes: ["2.5L", "5L"] },
    "Crown Trade Timonox Acrylic Eggshell": { handle: "crown-trade-eggshell-25l-tinted-platinum-base", name: "Crown Trade Timonox Eggshell", type: "Fire Retardant Eggshell", desc: "Fire retardant trim", sizes: ["2.5L"] },
    // Crown Trade Specialty
    "Crown Trade Covermatt Obliterating Emulsion": { handle: "crown-trade-vinyl-matt", name: "Crown Trade Covermatt", type: "Obliterating Emulsion", desc: "High coverage matt", sizes: ["2.5L", "5L"] },
    "Crown Trade Fast Drying Concrete Floor Paint": { handle: "macpherson-floor-paint-tinted-mc3", name: "Crown Trade Floor Paint", type: "Floor Paint", desc: "Concrete floors", sizes: ["2.5L", "5L"] },
    "Crown Trade Stronghold Smooth Masonry Paint": { handle: "sandtex-high-cover-smooth-5l-tinted-crystal-base", name: "Crown Trade Stronghold", type: "Masonry Paint", desc: "Exterior masonry", sizes: ["5L"] },
    "Crown Trade Protective Coatings Fast Drying Cladding Finish": { handle: "crown-trade-fastflow-quick-dry-satin-tinted", name: "Crown Trade Cladding Finish", type: "Cladding Paint", desc: "Metal cladding", sizes: ["2.5L", "5L"] },
    "Crown Trade Protective Coatings High Performance Gloss for Metal": { handle: "crown-trade-fastflow-quick-dry-gloss-1l-tinted", name: "Crown Trade Metal Gloss", type: "Metal Gloss", desc: "Metal surfaces", sizes: ["1L", "2.5L"] },
    // Macpherson Specialty
    "Macpherson Marbletex Smooth": { handle: "sandtex-high-cover-smooth-5l-tinted-crystal-base", name: "Macpherson Marbletex", type: "Masonry Paint", desc: "Textured masonry", sizes: ["5L"] },
    "Macpherson Powerkote": { handle: "macpherson-eclipse-emulsion-tinted", name: "Macpherson Powerkote", type: "Durable Emulsion", desc: "High durability", sizes: ["5L", "10L"] },
    "Macpherson Quick dry Acrylic Primer Undercoat": { handle: "macpherson-gloss-tinted", name: "Macpherson Acrylic Primer", type: "Primer", desc: "Primer & undercoat", sizes: ["1L", "2.5L"] }
  };

  // Cache for product images
  var productImageCache = {};

  var state = {
    allColors: [],
    filteredColors: [],
    colorProducts: {}, // Loaded from color-products.js
    currentPage: 1,
    itemsPerPage: 24,
    viewMode: 'grid',
    filters: {
      search: '',
      families: [],
      collections: []
    },
    selectedColor: null
  };

  var elements = {};

  function waitForColorData(callback, maxWait) {
    maxWait = maxWait || 15000;
    var start = Date.now();
    var attempts = 0;
    (function check() {
      attempts++;
      if (window.PaintColorData && window.PaintColorData.colors && window.PaintColorData.colors.length > 0) {
        console.log('ColorPicker: Data ready after', attempts, 'checks,', window.PaintColorData.colors.length, 'colors');
        callback();
      } else if (Date.now() - start < maxWait) {
        setTimeout(check, 100);
      } else {
        console.error('ColorPicker: Failed to load color data after', maxWait, 'ms');
        var grid = document.getElementById('colorGrid');
        if (grid) grid.innerHTML = '<p style="padding:20px;text-align:center;">Failed to load colours. Please refresh the page.</p>';
      }
    })();
  }

  function init() {
    waitForColorData(function() {
      state.allColors = window.PaintColorData.colors;
      state.filteredColors = state.allColors.slice();

      cacheElements();
      renderFilters();
      renderColorGrid();
      renderPagination();
      bindEvents();

      console.log('ColorPicker: Initialized with', state.allColors.length, 'colors');

      // Load color products data
      loadColorProducts();
    });
  }

  function loadColorProducts() {
    // Check if already loaded
    if (window.ColorProductData) {
      state.colorProducts = window.ColorProductData;
      console.log('ColorPicker: Product data ready', Object.keys(state.colorProducts).length, 'colors');
      return;
    }

    // Try to load dynamically
    var script = document.createElement('script');
    // Get the base URL from color-data.js which we know loaded
    var scripts = document.querySelectorAll('script[src*="color-data.js"]');
    if (scripts.length > 0) {
      var baseUrl = scripts[0].src.replace('color-data.js', 'color-products.js').split('?')[0];
      script.src = baseUrl + '?v=' + Date.now();
      script.onload = function() {
        if (window.ColorProductData) {
          state.colorProducts = window.ColorProductData;
          console.log('ColorPicker: Loaded product data for', Object.keys(state.colorProducts).length, 'colors');
        }
      };
      document.head.appendChild(script);
    }
  }

  function cacheElements() {
    elements = {
      colorGrid: document.getElementById('colorGrid'),
      searchInput: document.getElementById('colorSearch'),
      familyFilters: document.getElementById('familyFilters'),
      collectionFilters: document.getElementById('collectionFilters'),
      resultsCount: document.getElementById('resultsCount'),
      pagination: document.getElementById('pagination'),
      productModal: document.getElementById('productSelectModal'),
      clearFiltersBtn: document.getElementById('clearFilters'),
      viewGridBtn: document.getElementById('viewGrid'),
      viewListBtn: document.getElementById('viewList'),
      filterToggleBtn: document.getElementById('filterToggle'),
      filterSidebar: document.getElementById('filterSidebar'),
      // Product filter elements
      brandFilters: document.getElementById('brandFilters'),
      surfaceFilters: document.getElementById('surfaceFilters'),
      finishFilters: document.getElementById('finishFilters')
    };
  }

  function bindEvents() {
    if (elements.searchInput) {
      elements.searchInput.addEventListener('input', debounce(handleSearch, 300));
    }
    if (elements.clearFiltersBtn) {
      elements.clearFiltersBtn.addEventListener('click', clearFilters);
    }
    if (elements.viewGridBtn) {
      elements.viewGridBtn.addEventListener('click', () => setViewMode('grid'));
    }
    if (elements.viewListBtn) {
      elements.viewListBtn.addEventListener('click', () => setViewMode('list'));
    }
    if (elements.filterToggleBtn) {
      elements.filterToggleBtn.addEventListener('click', toggleMobileFilters);
    }
    if (elements.productModal) {
      elements.productModal.addEventListener('click', function(e) {
        if (e.target === this || e.target.classList.contains('modal-close-btn')) {
          closeProductModal();
        }
      });
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && elements.productModal?.classList.contains('active')) {
        closeProductModal();
      }
    });
  }

  function renderFilters() {
    // Color Family Filters
    if (elements.familyFilters && window.PaintColorData.families) {
      var families = window.PaintColorData.families || [];
      var html = families.map(function(family) {
        var count;
        if (family === 'All') {
          count = state.allColors.length;
        } else {
          count = state.allColors.filter(function(c) { return c.family === family; }).length;
        }
        return '<div class="filter-option">' +
          '<input type="checkbox" id="family-' + slugify(family) + '" value="' + family + '" ' +
          'onchange="ColorPicker.toggleFamilyFilter(\'' + family + '\')">' +
          '<label for="family-' + slugify(family) + '">' + family + '</label>' +
          '<span class="count">' + count + '</span>' +
          '</div>';
      }).join('');
      elements.familyFilters.innerHTML = html;
    }

    // Collection Filters - only if collections exist
    if (elements.collectionFilters && window.PaintColorData.collections) {
      var collections = window.PaintColorData.collections || [];
      var html = collections.map(function(collection) {
        var count = state.allColors.filter(function(c) { return c.collection === collection; }).length;
        return '<div class="filter-option">' +
          '<input type="checkbox" id="collection-' + slugify(collection) + '" value="' + collection + '" ' +
          'onchange="ColorPicker.toggleCollectionFilter(\'' + collection + '\')">' +
          '<label for="collection-' + slugify(collection) + '">' + collection + '</label>' +
          '<span class="count">' + count + '</span>' +
          '</div>';
      }).join('');
      elements.collectionFilters.innerHTML = html;
    }
  }

  function renderColorGrid() {
    if (!elements.colorGrid) return;

    const startIndex = (state.currentPage - 1) * state.itemsPerPage;
    const endIndex = startIndex + state.itemsPerPage;
    const pageColors = state.filteredColors.slice(startIndex, endIndex);

    if (pageColors.length === 0) {
      elements.colorGrid.innerHTML = `
        <div class="no-results">
          <p>No colours found matching your criteria.</p>
          <button onclick="ColorPicker.clearFilters()" class="clear-filters-btn">Clear Filters</button>
        </div>
      `;
      return;
    }

    const html = pageColors.map(color => `
      <div class="color-swatch" data-color-id="${color.id}" onclick="ColorPicker.selectColor('${color.id}')">
        <div class="color-swatch-display">
          <div class="color-swatch-color" style="background-color: ${color.hex}"></div>
          <div class="color-swatch-overlay">
            <p class="color-overlay-text">
              <strong>${color.name}</strong>
              Code: ${color.code}<br>
              RGB: ${color.rgb}<br>
              HEX: ${color.hex}
            </p>
          </div>
        </div>
        <div class="color-swatch-info">
          <h3 class="color-name">${color.name}</h3>
          <p class="color-code">${color.code}</p>
          <button class="add-to-paint-btn" onclick="event.stopPropagation(); ColorPicker.selectColor('${color.id}')">
            Choose Paint
          </button>
        </div>
      </div>
    `).join('');

    elements.colorGrid.innerHTML = html;
    elements.colorGrid.className = `color-grid view-${state.viewMode}`;

    if (elements.resultsCount) {
      elements.resultsCount.innerHTML = `
        Showing <strong>${startIndex + 1}-${Math.min(endIndex, state.filteredColors.length)}</strong>
        of <strong>${state.filteredColors.length}</strong> colours
      `;
    }
  }

  function renderPagination() {
    if (!elements.pagination) return;
    const totalPages = Math.ceil(state.filteredColors.length / state.itemsPerPage);
    if (totalPages <= 1) {
      elements.pagination.innerHTML = '';
      return;
    }

    let html = `<button class="pagination-btn" onclick="ColorPicker.goToPage(${state.currentPage - 1})" ${state.currentPage === 1 ? 'disabled' : ''}>&laquo;</button>`;

    const maxVisible = 5;
    let startPage = Math.max(1, state.currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage < maxVisible - 1) startPage = Math.max(1, endPage - maxVisible + 1);

    if (startPage > 1) {
      html += `<button class="pagination-btn" onclick="ColorPicker.goToPage(1)">1</button>`;
      if (startPage > 2) html += `<span class="pagination-ellipsis">...</span>`;
    }

    for (let i = startPage; i <= endPage; i++) {
      html += `<button class="pagination-btn ${i === state.currentPage ? 'active' : ''}" onclick="ColorPicker.goToPage(${i})">${i}</button>`;
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) html += `<span class="pagination-ellipsis">...</span>`;
      html += `<button class="pagination-btn" onclick="ColorPicker.goToPage(${totalPages})">${totalPages}</button>`;
    }

    html += `<button class="pagination-btn" onclick="ColorPicker.goToPage(${state.currentPage + 1})" ${state.currentPage === totalPages ? 'disabled' : ''}>&raquo;</button>`;
    elements.pagination.innerHTML = html;
  }

  function handleSearch(e) {
    state.filters.search = e.target.value;
    state.currentPage = 1;
    filterColors();
  }

  function toggleFamilyFilter(family) {
    // "All" clears all family filters
    if (family === 'All') {
      state.filters.families = [];
      // Uncheck all family checkboxes
      if (elements.familyFilters) {
        var checkboxes = elements.familyFilters.querySelectorAll('input[type="checkbox"]');
        for (var i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false;
        }
      }
    } else {
      const idx = state.filters.families.indexOf(family);
      if (idx > -1) state.filters.families.splice(idx, 1);
      else state.filters.families.push(family);
    }
    state.currentPage = 1;
    filterColors();
  }

  function toggleCollectionFilter(collection) {
    const idx = state.filters.collections.indexOf(collection);
    if (idx > -1) state.filters.collections.splice(idx, 1);
    else state.filters.collections.push(collection);
    state.currentPage = 1;
    filterColors();
  }

  function toggleBrandFilter(brand) {
    const idx = state.productFilters.brands.indexOf(brand);
    if (idx > -1) state.productFilters.brands.splice(idx, 1);
    else state.productFilters.brands.push(brand);
  }

  function toggleSurfaceFilter(surface) {
    const idx = state.productFilters.surfaces.indexOf(surface);
    if (idx > -1) state.productFilters.surfaces.splice(idx, 1);
    else state.productFilters.surfaces.push(surface);
  }

  function filterColors() {
    state.filteredColors = state.allColors.filter(color => {
      if (state.filters.search) {
        const s = state.filters.search.toLowerCase();
        if (!(color.name.toLowerCase().includes(s) || color.code.toLowerCase().includes(s) || color.hex.toLowerCase().includes(s))) return false;
      }
      if (state.filters.families.length > 0 && !state.filters.families.includes(color.family)) return false;
      if (state.filters.collections.length > 0 && !state.filters.collections.includes(color.collection)) return false;
      return true;
    });
    renderColorGrid();
    renderPagination();
  }

  function clearFilters() {
    state.filters = { search: '', families: [], collections: [] };
    state.productFilters = { brands: [], surfaces: [], finishes: [] };
    state.currentPage = 1;
    if (elements.searchInput) elements.searchInput.value = '';
    document.querySelectorAll('.filter-option input[type="checkbox"]').forEach(cb => cb.checked = false);
    filterColors();
  }

  function goToPage(page) {
    const totalPages = Math.ceil(state.filteredColors.length / state.itemsPerPage);
    if (page < 1 || page > totalPages) return;
    state.currentPage = page;
    renderColorGrid();
    renderPagination();
    if (elements.colorGrid) elements.colorGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function setViewMode(mode) {
    state.viewMode = mode;
    if (elements.viewGridBtn) elements.viewGridBtn.classList.toggle('active', mode === 'grid');
    if (elements.viewListBtn) elements.viewListBtn.classList.toggle('active', mode === 'list');
    renderColorGrid();
  }

  function toggleMobileFilters() {
    if (elements.filterSidebar) elements.filterSidebar.classList.toggle('mobile-open');
  }

  // Helper to find color by ID
  function findColorById(colorId) {
    if (!state.allColors || !state.allColors.length) return null;
    for (var i = 0; i < state.allColors.length; i++) {
      if (state.allColors[i].id === colorId) return state.allColors[i];
    }
    return null;
  }

  function selectColor(colorId) {
    var color = typeof colorId === 'object' ? colorId : findColorById(colorId);
    if (!color) {
      console.log('Color not found:', colorId);
      return;
    }
    state.selectedColor = color;
    showProductModal(color);
  }

  function showProductModal(color) {
    if (!elements.productModal) {
      // No modal - go directly to browse with color
      window.location.href = '/collections/tinted-paints?color=' + encodeURIComponent(color.id) + '&color_name=' + encodeURIComponent(color.name) + '&color_hex=' + encodeURIComponent(color.hex);
      return;
    }

    // Update modal header
    var previewSwatch = elements.productModal.querySelector('.preview-swatch');
    var previewName = elements.productModal.querySelector('.preview-info h3');
    var previewDetails = elements.productModal.querySelector('.preview-info p');
    var productList = elements.productModal.querySelector('.product-list');

    if (previewSwatch) previewSwatch.style.backgroundColor = color.hex;
    if (previewName) previewName.textContent = color.name;
    if (previewDetails) previewDetails.innerHTML = 'Code: <strong>' + (color.code || color.id) + '</strong> | HEX: ' + color.hex;

    // Render product cards
    if (productList) {
      renderProductCards(productList, color);
    }

    elements.productModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function renderProductCards(container, color) {
    // Get available products for this color from scraped data
    var colorData = state.colorProducts[color.id];
    var availableCrownProducts = (colorData && colorData.products) ? colorData.products : [];

    // Map to Shopify products (removing duplicates by handle)
    var availableProducts = [];
    var seenHandles = {};

    for (var i = 0; i < availableCrownProducts.length; i++) {
      var crownProduct = availableCrownProducts[i];
      var mapped = PRODUCT_MAPPING[crownProduct];
      if (mapped && !seenHandles[mapped.handle]) {
        seenHandles[mapped.handle] = true;
        availableProducts.push(mapped);
      }
    }

    if (availableProducts.length === 0) {
      container.innerHTML = '<p style="text-align:center;color:#666;padding:20px;">No paint products available for this colour. Please contact us for availability.</p>';
      return;
    }

    var html = '';
    for (var j = 0; j < availableProducts.length; j++) {
      var pt = availableProducts[j];
      var productUrl = '/products/' + pt.handle + '?color=' + encodeURIComponent(color.id) + '&color_name=' + encodeURIComponent(color.name) + '&color_hex=' + encodeURIComponent(color.hex);

      html += '<a href="' + productUrl + '" class="product-type-btn" data-handle="' + pt.handle + '" style="display:flex;align-items:center;gap:14px;padding:14px 16px;background:#fff;border:1px solid #e5e7eb;border-radius:10px;margin-bottom:10px;text-decoration:none;color:inherit;transition:all 0.2s;box-shadow:0 1px 3px rgba(0,0,0,0.05);">' +
        '<div class="product-thumb" style="width:60px;height:60px;border-radius:8px;background:#f3f4f6;flex-shrink:0;overflow:hidden;display:flex;align-items:center;justify-content:center;">' +
        '<img src="" alt="' + pt.name + '" style="width:100%;height:100%;object-fit:contain;display:none;" onload="this.style.display=\'block\';this.nextElementSibling.style.display=\'none\';">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="12" cy="10" r="3"/><path d="M6 21v-1a6 6 0 0112 0v1"/></svg>' +
        '</div>' +
        '<div style="flex:1;min-width:0;">' +
        '<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px;">' +
        '<strong style="color:#2c3e50;font-size:14px;">' + pt.name + '</strong>' +
        '</div>' +
        '<div style="display:inline-block;background:linear-gradient(135deg,#8b5cf6,#6366f1);color:#fff;font-size:11px;font-weight:600;padding:3px 8px;border-radius:4px;margin-bottom:6px;">' + (pt.type || 'Paint') + '</div>' +
        '<div style="font-size:12px;color:#666;">' + pt.desc + '</div>' +
        '<div style="font-size:11px;color:#9ca3af;margin-top:2px;">Sizes: ' + pt.sizes.join(', ') + '</div>' +
        '</div>' +
        '<div style="display:flex;flex-direction:column;align-items:center;gap:4px;">' +
        '<div style="width:32px;height:32px;border-radius:6px;background:' + color.hex + ';border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,0.15);"></div>' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>' +
        '</div>' +
        '</a>';
    }

    container.innerHTML = html;

    // Load product images
    loadProductImages(container, availableProducts);
  }

  function loadProductImages(container, products) {
    products.forEach(function(pt) {
      // Check cache first
      if (productImageCache[pt.handle]) {
        setProductImage(container, pt.handle, productImageCache[pt.handle]);
        return;
      }

      // Fetch product JSON to get image
      fetch('/products/' + pt.handle + '.json')
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data.product && data.product.image && data.product.image.src) {
            var imgUrl = data.product.image.src;
            // Use smaller image size
            imgUrl = imgUrl.replace(/\.([^.]+)$/, '_200x200.$1');
            productImageCache[pt.handle] = imgUrl;
            setProductImage(container, pt.handle, imgUrl);
          }
        })
        .catch(function() {
          // Silently fail - placeholder icon will show
        });
    });
  }

  function setProductImage(container, handle, imgUrl) {
    var card = container.querySelector('[data-handle="' + handle + '"]');
    if (card) {
      var img = card.querySelector('.product-thumb img');
      if (img) {
        img.src = imgUrl;
      }
    }
  }

  function toggleProductFilter(type, value) {
    if (type === 'brand') {
      const idx = state.productFilters.brands.indexOf(value);
      if (idx > -1) state.productFilters.brands.splice(idx, 1);
      else state.productFilters.brands.push(value);
    } else if (type === 'surface') {
      const idx = state.productFilters.surfaces.indexOf(value);
      if (idx > -1) state.productFilters.surfaces.splice(idx, 1);
      else state.productFilters.surfaces.push(value);
    }

    // Re-render
    const filterContainer = elements.productModal?.querySelector('.product-filters');
    const productList = elements.productModal?.querySelector('.product-list');
    if (filterContainer) filterContainer.innerHTML = renderProductFilters();
    if (productList && state.selectedColor) renderProductCards(productList, state.selectedColor);
  }

  function clearProductFilters() {
    state.productFilters = { brands: [], surfaces: [], finishes: [] };
    const filterContainer = elements.productModal?.querySelector('.product-filters');
    const productList = elements.productModal?.querySelector('.product-list');
    if (filterContainer) filterContainer.innerHTML = renderProductFilters();
    if (productList && state.selectedColor) renderProductCards(productList, state.selectedColor);
  }

  function closeProductModal() {
    if (elements.productModal) {
      elements.productModal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  // Utilities
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  function slugify(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  // Public API
  window.ColorPicker = {
    init,
    selectColor,
    toggleFamilyFilter,
    toggleCollectionFilter,
    toggleProductFilter,
    clearProductFilters,
    clearFilters,
    goToPage,
    setViewMode,
    closeProductModal,
    getState: () => state
  };

  // Auto-init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
